import { useContext } from "react";
import ThemeContext from "../contexts/themeContext";

export default function useDarkMode() {
  const { darkModeStatus, setDarkModeStatus } = useContext(ThemeContext);

  const themeStatus: "light" | "dark" = darkModeStatus ? "light" : "dark";

  return { themeStatus, darkModeStatus, setDarkModeStatus };
}
